import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mark_as_done, startCourse } from 'store/modules/course_store/actions';
import Loader from 'components/atoms/loader';
import RadioButtonSelect from 'components/atoms/radio_button_select';
import { ApplicationState } from 'store';
import {
  ProgressionCourseState,
  ProgressionCoursesTypes,
} from 'store/modules/progression_course_store/types';
import {
  current_class_status,
  getLastClass,
  PreviousClass,
} from 'store/modules/progression_course_store/actions';
import Previous from 'assets/images/seta_esquerda.svg';
import Next from 'assets/images/seta_direita.svg';
import BlockedCourseCard from 'components/atoms/blocked_course_card';
import FinishedCourse from '../finished_course';
import { Container } from './styles';

interface ViewCourseProps {
  searchBarOpened: boolean;
  subscriber: boolean;
  videoRef: React.RefObject<HTMLDivElement>;
}

const ViewCourse = (props: ViewCourseProps) => {
  const { searchBarOpened, subscriber, videoRef } = props;
  const dispatch = useDispatch();
  const { progression_course, request } = useSelector<ApplicationState, ProgressionCourseState>(
    (state) => state.session.progression_course,
  );

  const [isBlocked, setIsBlocked] = useState<boolean>(!progression_course?.last_lasson?.free);

  useEffect(() => {
    setIsBlocked(!progression_course?.last_lasson?.free);
  }, [progression_course?.last_lasson?.free]);

  const handleClick = () => {
    dispatch(mark_as_done(Number(progression_course?.last_lasson?.id)));
    dispatch(getLastClass(2));
  };

  const toggleConcluded = (id: string, updateAll = false) => {
    if (!updateAll) dispatch(mark_as_done(Number(id)));
  };

  const progression =
    (Number(progression_course?.progression) / Number(progression_course?.total_aula)) * 100;

  useEffect(() => {
    dispatch(PreviousClass(progression_course?.last_lasson?.ordem, 2));
    dispatch(current_class_status(progression_course?.last_lasson?.id));
  }, [progression_course?.last_lasson?.ordem]);

  return (
    <Container>
      <div
        className={`result-container col-12 ${
          searchBarOpened ? 'col-lg-8 margin ' : 'col-md-12 px-5'
        }`}
      >
        {!progression_course?.last_lasson?.nome &&
          request?.get_progression_course?.loaded &&
          progression_course?.total_aula === 0 && (
            <div className="alert alert-primary text-center mt-3" role="alert">
              Você está visualizando este curso sem iniciá-lo. Você precisa iniciar o curso para ter
              seu certificado.
              <button
                type="button"
                className="btn btn-primary ml-2 btn-sm"
                onClick={() => dispatch(startCourse(2))}
              >
                Iniciar curso
              </button>
            </div>
          )}

        {progression_course?.last_lasson?.nome && request?.get_progression_course?.loaded && (
          <div className="row my-3" ref={videoRef}>
            <div className="col-md-6 d-flex">
              {progression_course?.previous[0]?.nome && (
                <>
                  <button
                    type="button"
                    className="btn btn-light border border-secondary"
                    onClick={() =>
                      dispatch({
                        type: ProgressionCoursesTypes.LAST_CLASS,
                        last_class: progression_course?.previous[0],
                      })
                    }
                  >
                    <img className="card-img-top" src={Previous} alt="previous" />
                  </button>
                  <div className="seta ml-3">
                    <p className="mb-0">Anterior</p>
                    <p className="mb-0">{progression_course?.previous[0]?.nome}</p>
                  </div>
                </>
              )}
            </div>

            <div className="col-md-6 d-flex justify-content-end">
              {progression_course?.next[0]?.nome && (
                <>
                  <div className="seta text-right mr-3">
                    <p className="mb-0">Próximo</p>
                    <p className="mb-0">{progression_course?.next[0]?.nome}</p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-light border border-secondary"
                    onClick={() =>
                      dispatch({
                        type: ProgressionCoursesTypes.LAST_CLASS,
                        last_class: progression_course?.next[0],
                      })
                    }
                  >
                    <img className="card-img-top" src={Next} alt="next" />
                  </button>
                </>
              )}
            </div>
          </div>
        )}
        {progression === 100 && !progression_course?.last_lasson?.nome ? (
          <FinishedCourse />
        ) : (
          <div className="card mt-2">
            {progression_course?.last_lasson ? (
              <>
                <div className="row px-3 mt-4">
                  <div className="col-md-8">
                    <h5 className="card-title mt-3">{progression_course?.last_lasson?.nome}</h5>
                  </div>
                  <div className="col-md-4 text-md-right">
                    <button type="button" className="btn-concluir pr-3" onClick={handleClick}>
                      <RadioButtonSelect
                        isChecked={progression_course?.concluded}
                        text={String(progression_course?.last_lasson?.id)}
                        toggleSelectContracts={toggleConcluded}
                      />
                      Marcar como concluída
                    </button>
                  </div>
                </div>
                <div className="card-body text-center" style={{ position: 'relative' }}>
                  <div
                    className="video-container"
                    style={{ padding: '56.25% 0 0 0', position: 'relative' }}
                  >
                    {isBlocked && !subscriber && (
                      <>
                        <div className="block" />
                        <BlockedCourseCard />
                      </>
                    )}
                    <iframe
                      src={progression_course?.last_lasson?.url_video}
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      onError={() => setIsBlocked(true)}
                      style={{
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                      }}
                      title={progression_course?.last_lasson?.nome}
                    />
                  </div>
                </div>
              </>
            ) : (
              <Loader />
            )}
          </div>
        )}
        {subscriber && (
          <div className="card mt-2">
            <div className="card-body d-flex justify-content-between align-items-center">
              <div>
                <h6>Material de Apoio</h6>
                <p className="mb-0">Tenha acesso ao material de apoio para essa aula</p>
              </div>
              <a
                href="https://conlicitacao.com.br/iaml-material-de-apoio/"
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Acessar material de apoio
              </a>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default ViewCourse;
